let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9pe8z")).then(() => parcelRequire('bNJJq'));